module.exports = __webpack_public_path__ + "img/p3_9.ae7df874.png";